import './App.css';
import "bootswatch/dist/darkly/bootstrap.min.css";
import { Route, useHistory } from "react-router-dom";
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { LoginCallback, Security, SecureRoute } from '@okta/okta-react';
import { Row, Col } from 'react-bootstrap';
import Jobs from './jobs/Jobs';
import logo from './logo.png'

const oktaAuth = new OktaAuth({
  issuer: process.env.REACT_APP_ISSUER_URI,
  clientId: process.env.REACT_APP_CLIENT_ID,
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: ['api', 'openid', 'groups', 'profile'],
  disableHttpsCheck: true,
  pkce: true,
});

function App() {
  const history = useHistory();
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    const url = toRelativeUrl(originalUri || '/', window.location.origin);
    history.replace(url);
  };

  return (
    <div className="App">
      <Row>
        <Col xs={1}>
          <div className='text-align-center'>
            <img src={logo} alt="cron-jobs-logo" />
          </div>
        </Col>
        <Col xs={11}>
          <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <Route path="/login/callback" exact component={LoginCallback} />
            <SecureRoute path="/" exact component={Jobs} />
          </Security>
        </Col>
      </Row>
    </div>
  );
}

export default App;
